import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    font-size: 14px;
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.textPrimary};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: ${props => props.theme.fontWeights.semibold};
    line-height: 1.2;
    margin-bottom: ${props => props.theme.spacing.md};
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.xxxl};
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.xxl};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.xl};
  }

  h4 {
    font-size: ${props => props.theme.fontSizes.lg};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: ${props => props.theme.transitions.fast};

    &:hover {
      color: ${props => props.theme.colors.primaryDark};
    }
  }

  button {
    font-family: ${props => props.theme.fonts.primary};
    cursor: pointer;
    border: none;
    outline: none;
    transition: ${props => props.theme.transitions.fast};
    /* Minimum touch target: 44px per Apple HIG / WCAG 2.5.5 */
    min-height: 44px;
  }

  input, textarea, select {
    font-family: ${props => props.theme.fonts.primary};
    outline: none;
    /* Comfortable touch target */
    min-height: 44px;

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px ${props => props.theme.colors.primary}18;
    }
  }

  /* Prevent iOS auto-zoom on input focus */
  @media (max-width: 768px) {
    input, textarea, select {
      font-size: 16px !important;
    }
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.border};
    border-radius: 99px;

    &:hover {
      background: ${props => props.theme.colors.textLight};
    }
  }

  /* Print styles */
  @media print {
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    body {
      background-color: white !important;
      color: black !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    /* Ocultar elementos de navegación */
    header,
    nav,
    .sidebar,
    .no-print,
    button:not(.print-visible),
    .action-buttons {
      display: none !important;
    }

    /* Ocultar scrollbars en impresión */
    ::-webkit-scrollbar {
      display: none !important;
    }

    /* Optimizar para impresión */
    .print-content {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 20px !important;
      box-shadow: none !important;
    }

    /* Evitar saltos de página en elementos */
    h1, h2, h3, h4, h5, h6 {
      page-break-after: avoid !important;
    }

    table, img, figure {
      page-break-inside: avoid !important;
    }

    /* Ajustar márgenes de página */
    @page {
      margin: 1cm;
      size: letter;
    }
  }
`;
